import React from 'react';
import { Redirect } from 'umi';
import * as queryString from 'query-string';

const Index = ({
  history: {
    location: { search },
  },
}) => (
  <Redirect
    to={queryString.stringifyUrl({
      url: '/foster-apply-list',
      query: {
        ...queryString.parse(search),
        platform: 'personal',
      },
    })}
  />
);
export default Index;
